import { $api } from "../AxiosInstance";

export class UserService {
  /**
   * Get admin user
   */
  static async getAdminUser() {
    return await $api.get("/api/users/adminUser");
  }

  /**
   * Get authenticated user
   * @returns {Promise<Object|null>}
   */
  static async usersGetAuthUser() {
    return await $api
      .get("/api/users/authUser")
      .then((res) => res.data)
      .catch(() => null);
  }

  /**
   * Get authenticated user (async version)
   */
  static async usersGetAuthUserAsync() {
    return await $api.get("/api/users/authUser");
  }

  /**
   * Get user info/profile
   */
  static async getUserInfo() {
    return await $api.get("/api/admin/v1/user/v1/profile");
  }

  /**
   * Get all users balance by date
   * @param {String} date
   */
  static async usersGetAllBalance(date) {
    return await $api.post("/api/admin/balanceHistory/sumByDate", { date });
  }

  /**
   * Get all users with pagination
   * @param {Object} params
   * @param {Number} params.page
   * @param {Number} params.size
   * @param {String} [params.sort]
   * @param {String} [params.search]
   */
  static async usersGetAll({ page, size, sort, search }) {
    return await $api.get("/api/users", {
      params: { page: page - 1, size, sort, search },
    });
  }

  /**
   * Get users with sorting
   * @param {Object} params
   * @param {Number} params.page
   * @param {Number} params.size
   * @param {String} params.sort
   * @param {Object} params.params
   */
  static async usersGetSort({ page, size, sort, params }) {
    return await $api.post("/api/admin/user/query", {
      page: page - 1,
      size,
      sort,
      params,
    });
  }

  /**
   * Get mocked users for auto tests
   */
  static async getMockedUsersForAutoTests() {
    return await $api.get("/api/admin/settings/testEmail/get");
  }

  /**
   * Create mocked users for auto tests
   * @param {Object} params
   */
  static async createMockedUsersForAutoTests(params) {
    return await $api.post("/api/admin/settings/testEmail/create", params);
  }

  /**
   * Update mocked users for auto tests
   * @param {Object} params
   */
  static async updateMockedUsersForAutoTests(params) {
    return await $api.post("/api/admin/settings/testEmail/update", params);
  }

  /**
   * Delete mocked users for auto tests
   * @param {Number} id
   */
  static async deleteMockedUsersForAutoTests(id) {
    return await $api.delete("/api/admin/settings/testEmail/delete", { params: { id } });
  }

  /**
   * Get user data by ID
   * @param {Number} id
   */
  static async userDataGetById(id) {
    return await $api.get("/api/admin/user/byId", {
      params: { id },
    });
  }

  /**
   * Get user balance history by user ID
   * @param {Object} params
   */
  static async userBalanseHistiryGetById(params) {
    return await $api.post("/api/admin/balanceHistory/byUser", params);
  }

  /**
   * Correct user balance
   * @param {Object} params
   */
  static async userBalanseCorrect(params) {
    return await $api.post("/api/admin/balance/correct", params);
  }

  /**
   * Set user password
   * @param {Object} params
   */
  static async userSetPassword(params) {
    return await $api.post("/api/users/setPassword", params);
  }

  /**
   * Get all users without pagination
   */
  static async usersGetAllNoPage() {
    return await $api.get("/api/users/no-page");
  }

  /**
   * Get user profile
   */
  static async userProfile() {
    return await $api.get(`/api/users/profile`);
  }

  /**
   * Get user entity by ID
   * @param {Number} id
   */
  static async usersGetUser(id) {
    return await $api.get("/api/users/entity", { params: { id } });
  }

  /**
   * Set new password for user
   * @param {String} newPassword
   */
  static async usersSetNewPassword(newPassword) {
    return await $api.post("/api/users/password", newPassword);
  }

  /**
   * Create new user
   * @param {Object} user
   * @param {String} user.name
   * @param {String} user.email
   * @param {String} user.password
   */
  static async usersCreate(user) {
    return await $api.post("/api/users/createUser", {
      name: user.name,
      email: user.email,
      password: user.password,
      roles: [],
    });
  }

  /**
   * Delete user by ID
   * @param {Number} id
   */
  static async usersDelete(id) {
    return await $api.delete("/api/users", { params: { id } });
  }

  /**
   * Save user profile
   * @param {Object} userProfile
   */
  static async usersSaveProfile(userProfile) {
    return await $api.post("/api/users/profile", userProfile);
  }

  /**
   * Get user IPs by email
   * @param {String} email
   * @param {Number} page
   * @param {Number} size
   */
  static async getIpsByEmail(email, page, size) {
    return await $api.post("/api/admin/clientIps/byEmail", { email, page, size });
  }

  /**
   * Get user IPs by ID
   * @param {Number} userId
   * @param {Number} page
   * @param {Number} size
   * @param {String} proxyType
   */
  static async getIpsById(userId, page, size, proxyType) {
    return await $api.post("/api/admin/clientIps/byId", {
      userId,
      page,
      size,
      proxyType,
    });
  }
}
